'use client'
import React, { useContext, useEffect, useState } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { Select } from 'chakra-react-select';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Skeleton
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import { AuthContext } from '@/auth/lib/authContext';
import useTranslation from '../../../lib/i18n/useTranslation';

const AddPersonaToSharedExperienceForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    onSubmitted,
    onSubmitting,
    sharedExperienceId,
    onCreateNew,
    onValidityChange
  } = props;
  const {
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();
  const { profile } = useContext(AuthContext);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [personaOptionsList, setPersonaOptionsList] = useState(null);
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const personaId = data.persona.value;
      await sharedExperiencesApi.linkPersonaToSharedExperience(sharedExperienceId, personaId);
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  const fetchData = async () => {
    try {
      const newPersonaList = await sharedExperiencesApi.fetchPersonasNotInSharedExperience(
        sharedExperienceId,
        profile.id
      );
      const newPersonaOptionsList = newPersonaList.map((p) => {
        return { label: p.name, value: p.id }
      });
      if (onCreateNew) {
        newPersonaOptionsList.unshift({
          label: '+ New Persona',
          value: -1,
        });
      }
      setPersonaOptionsList(newPersonaOptionsList);
    } catch (e) {
      console.error(e)
    }
  };
  useEffect(() => {
    if (sharedExperienceId) {
      fetchData();
    }
  }, [sharedExperienceId]);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <Controller
          control={control}
          name="persona"
          rules={{ required: "Please enter at least one persona" }}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { invalid, error }
          }) => (
            <FormControl isInvalid={errors && errors.persona}>
              <FormLabel>{t('sharedExperience.selectPersona')}</FormLabel>
              {!personaOptionsList && (
                <Skeleton w={"100%"} height={"30px"} />
              )}
              {personaOptionsList && (
                <Select
                  options={personaOptionsList}
                  onChange={(e) => {
                    if (e.value === -1 && onCreateNew) {
                      onCreateNew();
                    } else {
                      onChange(e);
                    }
                  }}
                  onBlur={onBlur}
                  value={value}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              )}
              <FormErrorMessage>{errors && errors.persona}</FormErrorMessage>
            </FormControl>
          )}
        />
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});
export default AddPersonaToSharedExperienceForm; 